export default __webpack_public_path__ + "static/media/080_finish_bad.av1.7f0c56f6.mp4";